import { useEffect, useState } from 'react';
import { parseISO } from 'date-fns';
import { cn } from '@shared/lib/utils';

interface BookingCountdownProps {
  duration: string;
  onComplete: () => void;
  className?: string;
  label?: string;
}

export const BookingCountdown = ({ duration, onComplete, className, label }: BookingCountdownProps) => {
  const [timeLeft, setTimeLeft] = useState('Загрузка...');

  useEffect(() => {
    const safeDuration = duration.endsWith('Z') ? duration : duration + 'Z';
    const endTime = parseISO(safeDuration);

    const updateTimer = () => {
      const now = new Date();
      const diffInMs = endTime.getTime() - now.getTime();

      if (diffInMs <= 1000) {
        setTimeLeft('Время вышло!');
        onComplete();
        return;
      }

      const minutes = Math.floor(diffInMs / 60000);
      const seconds = Math.floor((diffInMs % 60000) / 1000);

      setTimeLeft(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
    };

    updateTimer();
    const timer = setInterval(updateTimer, 1000);

    return () => clearInterval(timer);
  }, [duration, onComplete]);

  return (
    <div className={cn('text-text-muted', className)}>
      <span>{label || 'Время для оплаты'} </span>
      <span className="font-semibold mr-1">{timeLeft}</span>
    </div>
  );
};
